import { render, staticRenderFns } from "./BookmarksForm.vue?vue&type=template&id=53a6b2d1&"
import script from "./BookmarksForm.vue?vue&type=script&lang=js&"
export * from "./BookmarksForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports